let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hQILJ")).then(() => parcelRequire('3HWgn'));